import { loadStripe } from '@stripe/stripe-js';
import { paymentAPI } from './api';

const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

let stripePromise = null;

const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
  }
  return stripePromise;
};

export const stripePayment = {
  // Create payment intent for Stripe
  createPaymentIntent: async (amount, currency = 'inr', orderId = null) => {
    try {
      const response = await paymentAPI.createStripeIntent(amount, currency, orderId);
      return response.data;
    } catch (error) {
      console.error('Error creating payment intent:', error);
      throw error;
    }
  },

  // Verify payment
  verifyPayment: async (paymentIntentId) => {
    try {
      const response = await paymentAPI.verifyStripePayment(paymentIntentId);
      return response.data;
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw error;
    }
  },

  // Get Stripe instance
  getStripeInstance: () => getStripe()
};

export default stripePayment;
